import {
     ADD_ADMIN_COUPONS,
     ADD_ADMIN_COUPON,
     UPDATE_ADMIN_COUPON,
     DELETE_ADMIN_COUPON
} from './actions';

const INITIAL_STATE = [];

const couponReducer = (state = INITIAL_STATE, action) => {
switch (action.type) {
     case ADD_ADMIN_COUPONS: {
          return action.payload;
     }
     case ADD_ADMIN_COUPON: {
          const newCoupons = [...state];
          newCoupons.push(action.payload);
          return newCoupons;
     }
     case UPDATE_ADMIN_COUPON: {
          const newCoupons = [...state];
          const _newCoupons = newCoupons.map((coupon) => {
               if (coupon.id === action.payload.couponId) {
                    return { ...coupon, ...action.payload.coupon };
               }
               return coupon;
          });
          return _newCoupons;
     }
     case DELETE_ADMIN_COUPON: {
          const newCoupons = [...state];
          return newCoupons.filter((coupon) => coupon.id !== action.payload);;
     }
     default:
          return state;
}
};

export const getCouponById = (state, cid) => state.admin.coupons.filter((coupon) => coupon.id === cid)[0];

export default couponReducer;